<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style="
            border-radius: 5px !important;
            padding-left: 0px;
            height: auto !important;
          "
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-nav>
            <b-button @click="goBack" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>{{ $route.name }}</b-navbar-brand>
          <b-navbar-nav class="ml-auto">
            <!-- <b-button
              class="pull-right mb-1"
              v-if="getTallyInvoiceList.length > 0"
              :disabled="ExcelBtnName != 'Export As Excel' ? true : false"
              @click="getReports('getAllBillingInvList', 'Export As Excel')"
              size="sm"
              variant="warning"
              style="font-size: 0.675rem"
            >
              {{ ExcelBtnName }}
              <b-spinner
                v-if="ExcelBtnName != 'Export As Excel'"
                small
                label="Small Spinner"
              ></b-spinner
            ></b-button> -->
          </b-navbar-nav>
        </b-navbar>

        <b-card class="formCard">
          <b-card-text>
            <div class="mt-3">
              <!-- Search Form Input Start-->
              <b-row>
                <b-col md="6" class="my-1">
                  <b-form-group>
                    <b-input-group>
                      <b-form-input
                        :formatter="capitalizeAll"
                        @input="debounceSearch"
                        v-model="filter"
                        placeholder="Type to Search "
                        ref="search"
                      />
                      <b-input-group-append>
                        <!-- :disabled="!filter" -->
                        <b-button
                          @click="
                            filterClear();
                            clearFilter();
                          "
                          >Clear</b-button
                        >
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col md="4">
                  <label for="blType">Date</label>
                  <date-range-picker
                    :opens="openRight"
                    :always-show-calendars="showCal"
                    v-model="dateRange"
                    :startDate="startDate"
                    :endDate="endDate"
                    :locale-data="locale"
                    @update="debounceSearch"
                  ></date-range-picker>
                </b-col>
                <b-col md="3">
                  <label>Type</label>
                  <model-list-select
                    :list="transportTypeName"
                    v-model="Filter.transportTypeFilter"
                    option-value="transportTypeVal"
                    option-text="transportTypeText"
                    placeholder="Select Export / Import"
                    @input="
                      debounceSearch();
                      clearBranch();
                    "
                  ></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>Service</label>
                  <model-list-select
                    :list="jobList"
                    v-model="Filter.jobTypeFilter"
                    option-value="jobVal"
                    option-text="jobText"
                    placeholder="Select Service"
                    @input="
                      debounceSearch();
                      clearBranch();
                    "
                  ></model-list-select>
                </b-col>
                <b-col md="3">
                  <label>Shipment Type</label>
                  <model-list-select
                    :list="shipmentTypeList"
                    v-model="Filter.shipmentTypeFilter"
                    option-value="shipmentTypeVal"
                    option-text="shipmentTypeText"
                    placeholder="Select Shipment Type"
                    @input="
                      debounceSearch();
                      clearBranch();
                    "
                  ></model-list-select>
                </b-col>
                <!-- <b-col md="3">
                  <label>Status</label>
                  <model-list-select
                    :list="statusList"
                    v-model="Filter.StatusFilter"
                    option-value="statusVal"
                    option-text="statusText"
                    placeholder="Select Status"
                    @input="
                      debounceSearch();
                      clearBranch();
                    "
                  ></model-list-select>
                </b-col> -->
                <b-col md="3">
                  <label>Client</label>
                  <model-list-select
                    :list="$store.getters['common/getAllClientList']"
                    id="clientNamenew"
                    v-model="Filter.clientIdFilter"
                    option-value="clientId"
                    option-text="clientName"
                    placeholder="Select Client Name"
                    @input="
                      debounceSearch();
                      clearBranch();
                    "
                  ></model-list-select>
                  <!-- :isDisabled="
                      $sessionsStorage.get('designation') != 'Admin' ? true : false
                    " -->
                </b-col>
                <b-col md="3">
                  <label>Branch</label>

                  <model-list-select
                    class="ml-1"
                    :list="$store.getters['common/getAllBranchList']"
                    id="BranchFilter"
                    v-model="Filter.BranchFilter"
                    option-value="pickupId"
                    option-text="pickupLocation"
                    placeholder="All"
                    @input="debounceSearch"
                  ></model-list-select>
                  <!-- :isDisabled="
                      $sessionsStorage.get('designation') != 'Admin' &&
                      $sessionsStorage.get('nameUser') != 'Bhavneesh'
                        ? true
                        : false
                    " -->
                </b-col>
                <b-col md="3">
                  <label>SLine</label>
                  <model-list-select
                    :list="$store.getters['common/getAllShippingLineList']"
                    v-model="Filter.SlineFilter"
                    option-value="shippingId"
                    option-text="shippingLine"
                    placeholder="Select Shipping Line"
                    @input="debounceSearch"
                  ></model-list-select>
                </b-col>
                <b-col md="3">
                  <label v-if="activeUserPreference">
                    <b> Created User Filter</b>
                  </label>
                  <model-list-select
                    v-if="activeUserPreference"
                    :list="$store.getters['common/getAllUserList']"
                    id="addedUserFilter"
                    @input="debounceSearch"
                    v-model="Filter.userFilter"
                    option-value="userId"
                    option-text="employeeName"
                    placeholder="Select Created User"
                  ></model-list-select>
                </b-col>

                <b-col md="3">
                  <userBasedClient
                    v-if="$sessionsStorage.get('userId')"
                    :PMC_title="'User Summary - ' + $sessionsStorage.get('employeeName')"
                    :PMC_USERID="Filter.userFilter"
                    :PMC_USERNAME="$sessionsStorage.get('nameUser')"
                    :PMC_USERDESIG="$sessionsStorage.get('designation')"
                    :PMC_BranchClientPre="$sessionsStorage.get('branchclientPre')"
                    :PMC_TransportTypePre="$sessionsStorage.get('transportTypePre')"
                    :PMC_UserEmpName="$sessionsStorage.get('employeeName')"
                    :PMC_UserEmpCode="$sessionsStorage.get('employeeCode')"
                  />
                </b-col>

                <b-col md="2"
                  ><h5>
                    <small v-if="isLoading == false">{{ totalRows }} Entries</small>
                  </h5></b-col
                >
              </b-row>
              <!-- Search Form Input End-->
              <!-- Main table element -->
              <div class="table-responsive tableMain">
                <b-table
                  show-empty
                  stacked="md"
                  :items="getTallyInvoiceList"
                  responsive
                  :fields="Columns"
                  primary-key="id_email_section"
                  :per-page="perPage"
                  :filter="filter"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :sort-direction="sortDirection"
                  @filtered="onFiltered"
                  class="position-relative"
                >
                  <template slot="SN" slot-scope="row0">
                    <span>{{ row0.index + 1 + (currentPage - 1) * perPage }}</span>
                    <BillingInvCard :PMC_item="row0.item" />
                    <br/>
                    <b-button
                      v-if="$sessionsStorage.get('is_Mobile') != 'port'"
                      size="sm"
                      class="mt-2"
                      style="font-size: 0.675rem"
                      @click="showDocModal(row0.item)"
                      variant="outline-info"
                      >Summary & Documents</b-button
                    >
                    <InvExpSummary
                      v-if="row0.item.allModuleId"
                      :PMC_title="'Inv Exp Summary Job No - ' + row0.item.JOBNO"
                      :PMC_JOBID="row0.item.allModuleId"
                      :PMC_JOBNO="row0.item.JOBNO"
                      :PMC_JOBDATE="row0.item.JOBDate | moment"
                      :PMC_JOBTYPE="row0.item.JobType"
                      :PMC_AgentType="''"
                      :PMC_Client="''"
                      :PMC_Sline="''"
                    />
                    <ContainerSummary
                      v-if="row0.item.allModuleId"
                      :PMC_title="'Container Summary Job No - ' + row0.item.JOBNO"
                      :PMC_JOBID="row0.item.allModuleId"
                      :PMC_JOBNO="row0.item.JOBNO"
                      :PMC_JOBDATE="row0.item.JOBDate | moment"
                      :PMC_JOBTYPE="row0.item.JobType"
                      :PMC_AgentType="''"
                      :PMC_Client="''"
                      :PMC_Sline="''"
                    />
                    <JobWisePaymentsDetails
                  v-if="row0.item.allModuleId"
                  :allModuleId="Number(row0.item.allModuleId)"
                  :JobNo="row0.item.JOBNO"
                  />
                  </template>
                  <!-- <template slot="JOBNO" slot-scope="row1">
                    <span v-if="row1.item.JOBNO">
                      JOBNO. :{{ row1.item.JOBNO }}
                      <br />
                      JOB Date :{{ row1.item.JOBDate }}
                      <br />
                      JOB Type :{{ row1.item.JOBTYPE }}
                      <br />
                      Client :{{ row1.item.clientName }}
                      <br />
                      SLine :{{ row1.item.shippingLine }}
                      <br />
                      Branch :{{ row1.item.Branch }}
                      <br />
                      Job Created By :{{ row1.item.RaisedBy }}
                      <br />
                      Shipment Type :{{ row1.item.shipmentType }}
                      <br />
                      Transport Type :{{ row1.item.transportType }}
                      <br />
                      Job Status :{{ row1.item.JOBStatus }}
                      <br />
                      Billing Status :{{ row1.item.finalBillingCompletedStatus }}
                      <br />
                      <b v-html="row1.item.assignmentCloseReason"
                        >Close Reason :{{ row1.item.assignmentCloseReason }}</b
                      >
                      <br />
                      Manifestation Status :{{ row1.item.is_maniFestSend }}
                      <br />
                    </span>
                  </template>
                  <template slot="FFCreatedDate" slot-scope="row2">
                    <span
                      v-if="
                        row2.item.FFCreatedDate &&
                        row2.item.isMiscJob == '0' &&
                        row2.item.JOBTYPE.indexOf('FF') >= 0
                      "
                    >
                      FF Req CD. :{{ row2.item.FFCreatedDate }}<br />
                    </span>
                    <span
                      v-if="
                        row2.item.FFCUserName &&
                        row2.item.isMiscJob == '0' &&
                        row2.item.JOBTYPE.indexOf('FF') >= 0
                      "
                    >
                      FF Req CB. :{{ row2.item.FFCUserName }}<br />
                    </span>
                    <span
                      v-if="
                        row2.item.FFUpdateDate &&
                        row2.item.isMiscJob == '0' &&
                        row2.item.JOBTYPE.indexOf('FF') >= 0
                      "
                    >
                      FF Req UD. :{{ row2.item.FFUpdateDate }}<br />
                    </span>
                    <span
                      v-if="
                        row2.item.FFUUserName &&
                        row2.item.isMiscJob == '0' &&
                        row2.item.JOBTYPE.indexOf('FF') >= 0
                      "
                    >
                      FF Req UB. :{{ row2.item.FFUUserName }}<br />
                    </span>
                    <hr
                      v-if="
                        row2.item.FFUUserName &&
                        row2.item.isMiscJob == '0' &&
                        row2.item.JOBTYPE.indexOf('FF') >= 0
                      "
                    />
                    <span
                      v-if="
                        row2.item.CCCreatedDate &&
                        row2.item.isMiscJob == '0' &&
                        row2.item.JOBTYPE.indexOf('CC') >= 0
                      "
                    >
                      CC Req CD. :{{ row2.item.CCCreatedDate }}<br />
                    </span>
                    <span
                      v-if="
                        row2.item.CCCUserName &&
                        row2.item.isMiscJob == '0' &&
                        row2.item.JOBTYPE.indexOf('CC') >= 0
                      "
                    >
                      CC Req CB. :{{ row2.item.CCCUserName }}<br
                    /></span>
                    <span
                      v-if="
                        row2.item.CCUpdateDate &&
                        row2.item.isMiscJob == '0' &&
                        row2.item.JOBTYPE.indexOf('CC') >= 0
                      "
                    >
                      CC Req UD. :{{ row2.item.CCUpdateDate }}<br />
                    </span>
                    <span
                      v-if="
                        row2.item.CCUUserName &&
                        row2.item.isMiscJob == '0' &&
                        row2.item.JOBTYPE.indexOf('CC') >= 0
                      "
                    >
                      CC Req UB. :{{ row2.item.CCUUserName }}<br />
                    </span>
                    <hr
                      v-if="
                        row2.item.CCUUserName &&
                        row2.item.isMiscJob == '0' &&
                        row2.item.JOBTYPE.indexOf('CC') >= 0
                      "
                    />
                    <span
                      v-if="
                        row2.item.TPTCreatedDate &&
                        row2.item.isMiscJob == '0' &&
                        row2.item.JOBTYPE.indexOf('TPT') >= 0
                      "
                    >
                      TPT Req CD. :{{ row2.item.TPTCreatedDate }}<br />
                    </span>
                    <span
                      v-if="
                        row2.item.TPTCreatedDate &&
                        row2.item.TPTCUserName == '0' &&
                        row2.item.JOBTYPE.indexOf('TPT') >= 0
                      "
                    >
                      TPT Req CB. :{{ row2.item.TPTCUserName }} <br
                    /></span>
                    <span
                      v-if="
                        row2.item.TPTUpdateDate &&
                        row2.item.isMiscJob == '0' &&
                        row2.item.JOBTYPE.indexOf('TPT') >= 0
                      "
                    >
                      TPT Req UD. :{{ row2.item.TPTUpdateDate }}<br />
                    </span>
                    <span
                      v-if="
                        row2.item.TPTUUserName &&
                        row2.item.isMiscJob == '0' &&
                        row2.item.JOBTYPE.indexOf('TPT') >= 0
                      "
                    >
                      TPT Req UB. :{{ row2.item.TPTUUserName }}<br />
                    </span>

                    <span v-if="row2.item.MISCCreatedDate && row2.item.isMiscJob == '1'">
                      MISC Req CD. :{{ row2.item.MISCCreatedDate }}<br />
                    </span>
                    <span v-if="row2.item.TBMISCCUserName && row2.item.isMiscJob == '1'">
                      MISC Req CB. :{{ row2.item.TBMISCCUserName }}<br />
                    </span>
                    <span v-if="row2.item.MISCUpdateDate && row2.item.isMiscJob == '1'">
                      MISC Req UD. :{{ row2.item.MISCUpdateDate }}<br />
                    </span>
                    <span v-if="row2.item.TBMISCUUserName && row2.item.isMiscJob == '1'">
                      MISC Req UB. :{{ row2.item.TBMISCUUserName }} <br
                    /></span>
                  </template>

                  <template slot="TBCreatedDate" slot-scope="row3">
                    <span v-if="row3.item.TBInvNo && row3.item.isMiscJob == '0'"
                      >TB Inv. :{{ row3.item.TBInvNo }}<br />
                    </span>
                    <span v-if="row3.item.TBCreatedDate && row3.item.isMiscJob == '0'"
                      >TB CD. :{{ row3.item.TBCreatedDate }}<br />
                    </span>
                    <span v-if="row3.item.TBCUserName && row3.item.isMiscJob == '0'"
                      >TB CB. :{{ row3.item.TBCUserName }}<br />
                    </span>
                    <span v-if="row3.item.TBUpdateDate && row3.item.isMiscJob == '0'"
                      >TB UD. :{{ row3.item.TBUpdateDate }}<br />
                    </span>
                    <span v-if="row3.item.TBUUserName && row3.item.isMiscJob == '0'"
                      >TB UB. :{{ row3.item.TBUUserName }}<br />
                    </span>
                    <hr v-if="row3.item.TBUUserName && row3.item.isMiscJob == '0'" />
                    <span
                      v-if="
                        row3.item.TBFFInvNo &&
                        row3.item.isMiscJob == '0' &&
                        row3.item.JOBTYPE.indexOf('FF') >= 0
                      "
                    >
                      FF TB Inv. :{{ row3.item.TBFFInvNo }}<br />
                    </span>
                    <span
                      v-if="
                        row3.item.TBFFCreatedDate &&
                        row3.item.isMiscJob == '0' &&
                        row3.item.JOBTYPE.indexOf('FF') >= 0
                      "
                    >
                      FF TB CD. :{{ row3.item.TBFFCreatedDate }}<br />
                    </span>
                    <span
                      v-if="
                        row3.item.TBFFCUserName &&
                        row3.item.isMiscJob == '0' &&
                        row3.item.JOBTYPE.indexOf('FF') >= 0
                      "
                    >
                      FF TB CB. :{{ row3.item.TBFFCUserName }}<br />
                    </span>
                    <span
                      v-if="
                        row3.item.TBFFUpdateDate &&
                        row3.item.isMiscJob == '0' &&
                        row3.item.JOBTYPE.indexOf('FF') >= 0
                      "
                    >
                      FF TB UD. :{{ row3.item.TBFFUpdateDate }}<br />
                    </span>
                    <span
                      v-if="
                        row3.item.TBFFUUserName &&
                        row3.item.isMiscJob == '0' &&
                        row3.item.JOBTYPE.indexOf('FF') >= 0
                      "
                    >
                      FF TB UB. :{{ row3.item.TBFFUUserName }}<br />
                    </span>
                    <hr
                      v-if="
                        row3.item.TBFFUUserName &&
                        row3.item.isMiscJob == '0' &&
                        row3.item.JOBTYPE.indexOf('FF') >= 0
                      "
                    />
                    <span
                      v-if="
                        row3.item.TBCCInvNo &&
                        row3.item.isMiscJob == '0' &&
                        row3.item.JOBTYPE.indexOf('CC') >= 0
                      "
                    >
                      CC TB Inv. :{{ row3.item.TBCCInvNo }}<br />
                    </span>
                    <span
                      v-if="
                        row3.item.TBCCCreatedDate &&
                        row3.item.isMiscJob == '0' &&
                        row3.item.JOBTYPE.indexOf('CC') >= 0
                      "
                    >
                      CC TB CD. :{{ row3.item.TBCCCreatedDate }}<br />
                    </span>
                    <span
                      v-if="
                        row3.item.TBCCCUserName &&
                        row3.item.isMiscJob == '0' &&
                        row3.item.JOBTYPE.indexOf('CC') >= 0
                      "
                    >
                      CC TB CB. :{{ row3.item.TBCCCUserName }}<br />
                    </span>
                    <span
                      v-if="
                        row3.item.TBCCUpdateDate &&
                        row3.item.isMiscJob == '0' &&
                        row3.item.JOBTYPE.indexOf('CC') >= 0
                      "
                    >
                      CC TB UD. :{{ row3.item.TBCCUpdateDate }} <br
                    /></span>
                    <span
                      v-if="
                        row3.item.TBCCUUserName &&
                        row3.item.isMiscJob == '0' &&
                        row3.item.JOBTYPE.indexOf('CC') >= 0
                      "
                    >
                      CC TB UB. :{{ row3.item.TBCCUUserName }}<br />
                    </span>
                    <hr
                      v-if="
                        row3.item.TBCCUUserName &&
                        row3.item.isMiscJob == '0' &&
                        row3.item.JOBTYPE.indexOf('CC') >= 0
                      "
                    />
                    <span
                      v-if="
                        row3.item.TBTPTInvNo &&
                        row3.item.isMiscJob == '0' &&
                        row3.item.JOBTYPE.indexOf('TPT') >= 0
                      "
                    >
                      TPT TB Inv. :{{ row3.item.TBTPTInvNo }}<br />
                    </span>
                    <span
                      v-if="
                        row3.item.TBTPTCreatedDate &&
                        row3.item.isMiscJob == '0' &&
                        row3.item.JOBTYPE.indexOf('TPT') >= 0
                      "
                    >
                      TPT TB CD. :{{ row3.item.TBTPTCreatedDate }}<br />
                    </span>
                    <span
                      v-if="
                        row3.item.TBTPTCUserName &&
                        row3.item.isMiscJob == '0' &&
                        row3.item.JOBTYPE.indexOf('TPT') >= 0
                      "
                    >
                      TPT TB CB. :{{ row3.item.TBTPTCUserName }}<br />
                    </span>
                    <span
                      v-if="
                        row3.item.TBTPTUpdateDate &&
                        row3.item.isMiscJob == '0' &&
                        row3.item.JOBTYPE.indexOf('TPT') >= 0
                      "
                    >
                      TPT TB UD. :{{ row3.item.TBTPTUpdateDate }}<br />
                    </span>
                    <span
                      v-if="
                        row3.item.TBTPTUUserName &&
                        row3.item.isMiscJob == '0' &&
                        row3.item.JOBTYPE.indexOf('TPT') >= 0
                      "
                    >
                      TPT TB UB. :{{ row3.item.TBTPTUUserName }}<br />
                    </span>

                    <span v-if="row3.item.TBInvNo && row3.item.isMiscJob == '1'">
                      MISC TB Inv. :{{ row3.item.TBInvNo }}<br />
                    </span>
                    <span v-if="row3.item.TBCreatedDate && row3.item.isMiscJob == '1'">
                      MISC TB CD. :{{ row3.item.TBCreatedDate }}<br />
                    </span>
                    <span v-if="row3.item.TBCUserName && row3.item.isMiscJob == '1'">
                      MISC TB CB. :{{ row3.item.TBCUserName }}<br />
                    </span>
                    <span v-if="row3.item.TBUpdateDate && row3.item.isMiscJob == '1'">
                      MISC TB UD. :{{ row3.item.TBUpdateDate }}<br />
                    </span>
                    <span v-if="row3.item.TBUUserName && row3.item.isMiscJob == '1'">
                      MISC TB UB. :{{ row3.item.TBUUserName }}<br />
                    </span>
                  </template>

                  <template slot="RevCreatedDate" slot-scope="row4">
                    <span v-if="row4.item.RevInvNo"
                      >Rev. Inv. :{{ row4.item.RevInvNo }}<br />
                    </span>
                    <span v-if="row4.item.RevInvDate"
                      >Rev. Inv Date. :{{ row4.item.RevInvDate }}<br />
                    </span>
                    <span v-if="row4.item.RevInvAmt"
                      >Rev. Inv Amt. :{{ row4.item.RevInvAmt }}<br />
                    </span>
                    <span v-if="row4.item.RevCreatedDate"
                      >Rev. CD. :{{ row4.item.RevCreatedDate }}<br />
                    </span>
                    <span v-if="row4.item.RevUpdateDate"
                      >Rev. UD. :{{ row4.item.RevUpdateDate }}<br />
                    </span>
                    <hr v-if="row4.item.RevUpdateDate" />
                    <span
                      v-if="
                        row4.item.RevFFInvNo &&
                        row4.item.isMiscJob == '0' &&
                        row4.item.JOBTYPE.indexOf('FF') >= 0
                      "
                    >
                      FF Rev. Inv. :{{ row4.item.RevFFInvNo }}<br />
                    </span>
                    <span
                      v-if="
                        row4.item.RevFFInvDate &&
                        row4.item.isMiscJob == '0' &&
                        row4.item.JOBTYPE.indexOf('FF') >= 0
                      "
                      >Rev. FF Inv Date. :{{ row4.item.RevFFInvDate }}<br />
                    </span>
                    <span
                      v-if="
                        row4.item.RevFFInvAmt &&
                        row4.item.isMiscJob == '0' &&
                        row4.item.JOBTYPE.indexOf('FF') >= 0
                      "
                    >
                      FF Rev. Inv Amt:{{ row4.item.RevFFInvAmt }}<br />
                    </span>
                    <span
                      v-if="
                        row4.item.RevFFCreatedDate &&
                        row4.item.isMiscJob == '0' &&
                        row4.item.JOBTYPE.indexOf('FF') >= 0
                      "
                    >
                      FF Rev. CD. :{{ row4.item.RevFFCreatedDate }}<br />
                    </span>
                    <span
                      v-if="
                        row4.item.RevFFUpdateDate &&
                        row4.item.isMiscJob == '0' &&
                        row4.item.JOBTYPE.indexOf('FF') >= 0
                      "
                    >
                      FF Rev. UD. :{{ row4.item.RevFFUpdateDate }}<br />
                    </span>
                    <hr
                      v-if="
                        row4.item.RevFFUpdateDate &&
                        row4.item.isMiscJob == '0' &&
                        row4.item.JOBTYPE.indexOf('FF') >= 0
                      "
                    />
                    <span
                      v-if="
                        row4.item.RevCCInvNo &&
                        row4.item.isMiscJob == '0' &&
                        row4.item.JOBTYPE.indexOf('CC') >= 0
                      "
                    >
                      CC Rev. Inv. :{{ row4.item.RevCCInvNo }}<br />
                    </span>
                    <span
                      v-if="
                        row4.item.RevCCInvDate &&
                        row4.item.isMiscJob == '0' &&
                        row4.item.JOBTYPE.indexOf('CC') >= 0
                      "
                      >Rev. CC Inv Date. :{{ row4.item.RevCCInvDate }}<br />
                    </span>
                    <span
                      v-if="
                        row4.item.RevCCInvAmt &&
                        row4.item.isMiscJob == '0' &&
                        row4.item.JOBTYPE.indexOf('CC') >= 0
                      "
                    >
                      CC Rev. Inv Amt:{{ row4.item.RevCCInvAmt }}<br />
                    </span>
                    <span
                      v-if="
                        row4.item.RevCCCreatedDate &&
                        row4.item.isMiscJob == '0' &&
                        row4.item.JOBTYPE.indexOf('CC') >= 0
                      "
                    >
                      CC Rev. CD. :{{ row4.item.RevCCCreatedDate }}<br />
                    </span>
                    <span
                      v-if="
                        row4.item.RevCCUpdateDate &&
                        row4.item.isMiscJob == '0' &&
                        row4.item.JOBTYPE.indexOf('CC') >= 0
                      "
                    >
                      CC Rev. UD. :{{ row4.item.RevCCUpdateDate }} <br
                    /></span>
                    <hr
                      v-if="
                        row4.item.RevCCUpdateDate &&
                        row4.item.isMiscJob == '0' &&
                        row4.item.JOBTYPE.indexOf('CC') >= 0
                      "
                    />
                    <span
                      v-if="
                        row4.item.RevTPTInvNo &&
                        row4.item.isMiscJob == '0' &&
                        row4.item.JOBTYPE.indexOf('TPT') >= 0
                      "
                    >
                      TPT Rev. Inv. :{{ row4.item.RevTPTInvNo }}<br />
                    </span>
                    <span
                      v-if="
                        row4.item.RevTPTInvDate &&
                        row4.item.isMiscJob == '0' &&
                        row4.item.JOBTYPE.indexOf('TPT') >= 0
                      "
                      >Rev. TPT Inv Date. :{{ row4.item.RevTPTInvDate }}<br />
                    </span>

                    <span
                      v-if="
                        row4.item.RevTPTInvAmt &&
                        row4.item.isMiscJob == '0' &&
                        row4.item.JOBTYPE.indexOf('TPT') >= 0
                      "
                    >
                      TPT Rev. Inv Amt:{{ row4.item.RevTPTInvAmt }}<br />
                    </span>
                    <span
                      v-if="
                        row4.item.RevTPTCreatedDate &&
                        row4.item.isMiscJob == '0' &&
                        row4.item.JOBTYPE.indexOf('TPT') >= 0
                      "
                    >
                      TPT Rev. CD. :{{ row4.item.RevTPTCreatedDate }}<br />
                    </span>
                    <span
                      v-if="
                        row4.item.RevTPTUpdateDate &&
                        row4.item.isMiscJob == '0' &&
                        row4.item.JOBTYPE.indexOf('TPT') >= 0
                      "
                    >
                      TPT Rev. UD. :{{ row4.item.RevTPTUpdateDate }}<br />
                    </span>
                  </template> -->

                  <!-- <template slot="TallyBillingSeries" slot-scope="row5">
                    <div v-if="row5.item.TallyBillingSeries">
                      <span
                        v-for="(item1, index) in row5.item.TallyBillingSeries.split(',')"
                        :key="index"
                        ><h6>
                          <b-badge variant="light"
                            >{{ item1 == "" ? "-------" : item1 }}
                          </b-badge>
                        </h6></span
                      >
                    </div>
                    <span v-else>-----------</span>
                  </template>
                  <template slot="RevBillingSeries" slot-scope="row6">
                    <div v-if="row6.item.RevBillingSeries">
                      <span
                        v-for="(item1, index) in row6.item.RevBillingSeries.split(',')"
                        :key="index"
                        ><h6>
                          <b-badge variant="light"
                            >{{ item1 == "" ? "-------" : item1 }}
                          </b-badge>
                        </h6></span
                      >
                    </div>
                    <span v-else>-----------</span>
                  </template> -->
                  <!-- <template slot="TallyBillingSeriesWithLoginTimeAndDocDtlsNo" slot-scope="row7">
                    <div v-if="row7.item.TallyBillingSeriesWithLoginTimeAndDocDtlsNo">
                      <span
                        v-for="(item1, index) in row7.item.TallyBillingSeriesWithLoginTimeAndDocDtlsNo.split(',')"
                        :key="index"
                        ><h6>
                          <b-badge variant="light"
                            >{{ item1 == "" ? "-------" : item1 }}
                          </b-badge>
                        </h6></span
                      >
                    </div>
                    <span v-else>-----------</span>
                    <hr/>
                    <div v-if="row7.item.RevBillingSeries">
                      <span
                        v-for="(item1, index) in row7.item.RevBillingSeries.split(',')"
                        :key="index"
                        ><h6>
                          <b-badge variant="light"
                            >{{ item1 == "" ? "-------" : item1 }}
                          </b-badge>
                        </h6></span
                      >
                    </div>
                  </template> -->
                </b-table>
              </div>
              <b-row>
                <b-col md="12" class="my-1">
                  <b-pagination
                    limit="5"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    v-model="currentPage"
                    @change="onPageChange($event)"
                    class="my-0 pull-right"
                  />
                </b-col>
              </b-row>
            </div>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>
    <div>
      <b-modal
        class="modal-dialog-doc"
        size="xl"
        no-close-on-esc
        no-close-on-backdrop
        ref="doc-modal"
        hide-footer
        :title="'Assignment Summary & Documents - ' + JOBSERIES"
      >
        <div v-if="ALLMODULE">
          <doc-form :allModuleIdProp="ALLMODULE" :JOBSERIES="JOBSERIES" />
        </div>
        <b-button class="mt-3" variant="outline-danger" block @click="hideDocModal"
          >Close
        </b-button>
      </b-modal>

      <!-- Added By Priyanshu Singh For Billing Close Section Start -->
      <b-modal
        id="modal-close-conf"
        ref="modal-close-conf"
        title="Reason for Closing Assignment Billing"
        centered
        no-close-on-esc
        no-close-on-backdrop
        hide-footer
      >
        <h3>Confirmation</h3>
        <form ref="form">
          <b-form-group
            label="Remark"
            label-for="name-input"
            invalid-feedback="Name is required"
          >
            <b-form-textarea
              :formatter="capitalizeAll"
              rows="5"
              id="name-input"
              v-model="billingclosingReason"
              required
            ></b-form-textarea>
          </b-form-group>
        </form>
        <b-button
          :disabled="billingclosingReason ? false : true"
          variant="success"
          @click="closeBillOk"
        >
          Confirm & Close Billing</b-button
        >
        <b-button @click="closeModalConfirm" variant="danger" class="pull-right">
          Cancel</b-button
        >
      </b-modal>
      <!-- Added By Priyanshu Singh For Billing Close Section End -->
    </div>
    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
    ></md-dialog-alert>
  </div>
</template>

<script>
import CustomLoader from "../common/customLoader.vue";
import DateRangePicker from "vue2-daterange-picker";
import BillingInvCard from "./billingInvCard.vue";
import DatePicker from "vue2-datepicker";
import { ModelListSelect, MultiSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters.js";
import ClientUserService from "../../services/ClientUserService.js";
import CommonService from "../../services/CommonService.js";
import { globalPermissionStatus, lastVisitPage } from "../../helper/collection";
import userBasedClient from "../common/userBasedClient.vue";
import DocForm from "../allModuleForm/docLibrary.vue";
import InvExpSummary from "../common/moduleBasedInvExpSummary.vue";
import ContainerSummary from "../common/moduleBasedContaierSummary.vue";
import JobWisePaymentsDetails from "../common/jobWisePaymentsDetails.vue";
export default {
  beforeMount() {
    if (!this.$route.query.assignment) {
      this.getCurrentLastDate();
    }
    this.$store.dispatch(
      "common/setAllUserList",
      JSON.stringify({
        itemCode: "GET_USERLIST_Data",
      })
    );
    this.$store.dispatch(
      "common/setAllShippingLineList",
      JSON.stringify({
        itemCode: "ShippingLineList",
      })
    );
    this.$store.dispatch(
      "common/setAllBranchList",
      JSON.stringify({
        filter: "BranchList",
        active: "all",
      })
    );
    this.$store.dispatch(
      "common/setAllClientList",
      JSON.stringify({
        itemCode: "ClientList",
      })
    );
    lastVisitPage(this.$router.history.current.fullPath);
    if (
      this.$sessionsStorage.get("loginId") != undefined &&
      this.$sessionsStorage.get("loginId") != ""
    ) {
      this.$store.dispatch("setCurrentRoute", "/billInvDash");
      if (this.$route.query.assignment) {
        this.filter = this.$route.query.assignment;
        this.Filter = {
          jobTypeFilter: "",
          StatusFilter: "",
          shipmentTypeFilter: "",
          transportTypeFilter: "",
          userFilter: "",
          clientIdFilter: "",
          BranchFilter: "",
          SlineFilter: "",
        };
        this.dateRange = { startDate: "", endDate: "" };
      }
      if (
        globalPermissionStatus("Dashboard_Access") ||
        globalPermissionStatus("Accounts")
      ) {
        if (!this.$route.query.assignment && this.lastVisitPage && this.$sessionsStorage.get("lastVisitPage")) {
          this.fetchLastPage(this.lastVisitPage);
        } else {
          this.getAllBillingInvList("Normal", "0", "0", "1", "1");
        }
      } else {
        this.$router.push({
          path: "/dashboard",
        });
      }
    } else {
      this.$router.push({
        path: "/Login/",
      });
    }
  },
  data() {
    return {
      ALLMODULE: "",
      JOBSERIES: "",
      ALLMODULE: "",
      JOBSERIES: "",
      transportTypeName: [
        {
          transportTypeVal: "Export",
          transportTypeText: "Export",
        },
        {
          transportTypeVal: "Import",
          transportTypeText: "Import",
        },
      ],
      shipmentTypeList: [
        {
          shipmentTypeVal: "1",
          shipmentTypeText: "Sea",
        },
        {
          shipmentTypeVal: "2",
          shipmentTypeText: "Air",
        },
      ],
      statusList: [
        {
          statusVal: "Active",
          statusText: "Active",
        },
        {
          statusVal: "Inactive",
          statusText: "In-Active",
        },
        {
          statusVal: "3",
          statusText: "All",
        },
      ],
      jobList: [
        {
          jobVal: "FF",
          jobText: "FF",
        },
        {
          jobVal: "CC",
          jobText: "CC",
        },
        {
          jobVal: "TPT",
          jobText: "TPT",
        },
        {
          jobVal: "MISC",
          jobText: "MISC",
        },
        {
          jobVal: "All",
          jobText: "All",
        },
      ],
      ExcelBtnName: "Export As Excel",
      isLoading: false,
      selectDateFormat,
      activeButtonBranch:
        this.$sessionsStorage.get("branchclientPre") == "1" ? true : false,
      activeUserPreference: this.$sessionsStorage.get("user_pre") === "1" ? true : false,

      Filter: {
        jobTypeFilter: "FF",
        StatusFilter: "Active",
        shipmentTypeFilter: "1",
        transportTypeFilter: "Export",
        userFilter:
          this.$sessionsStorage.get("designation") == "Admin"
            ? ""
            : this.$sessionsStorage.get("departmentName").indexOf("Accounts") >= 0
            ? ""
            : this.$sessionsStorage.get("userId"),
        clientIdFilter: "",
        BranchFilter:
          this.$sessionsStorage.get("designation") == "Admin"
            ? ""
            : this.$sessionsStorage.get("branch_baseLocation"),
        SlineFilter: "",
      },
      Columns: [
        {
          key: "SN",
          mainkey: "SN",
          label: "",
          sortable: true,
          sortDirection: "ASC",
          table: "A.",
        },
        // {
        //   key: "JOBNO",
        //   mainkey: "JOBNO",
        //   label: "Job Details",
        //   sortable: true,
        //   sortDirection: "ASC",
        //   table: "B.",
        // },
        // {
        //   key: "FFCreatedDate",
        //   mainkey: "FFCreatedDate",
        //   label: "For Billing Desk",
        //   sortable: true,
        //   sortDirection: "ASC",
        //   table: "C.",
        // },
        // {
        //   key: "TBCreatedDate",
        //   mainkey: "TBCreatedDate",
        //   label: "Tally Inv",
        //   sortable: true,
        //   sortDirection: "ASC",
        //   table: "E.",
        // },
        // {
        //   key: "RevCreatedDate",
        //   mainkey: "RevCreatedDate",
        //   label: "Reverse Inv",
        //   sortable: true,
        //   sortDirection: "ASC",
        //   table: "F.",
        // },
        // {
        //   key: "TallyBillingSeries",
        //   mainkey: "TallyBillingSeries",
        //   label: "All Tally Inv",
        //   sortable: true,
        //   sortDirection: "ASC",
        //   table: "F.",
        // },
        // {
        //   key: "RevBillingSeries",
        //   mainkey: "RevBillingSeries",
        //   label: "All Reverse Inv",
        //   sortable: true,
        //   sortDirection: "ASC",
        //   table: "F.",
        // },
        // {
        //   key: "TallyBillingSeriesWithLoginTimeAndDocDtlsNo",
        //   mainkey: "TallyBillingSeriesWithLoginTimeAndDocDtlsNo",
        //   label: "Tally // Rev // Diff",
        //   sortable: true,
        //   sortDirection: "ASC",
        //   table: "F.",
        // },
      ],
      docURL: URL_BASE_DOC,
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      sortBy: null,
      sortDesc: false,
      pageOptions: [5, 10, 15],
      adminToggle: this.$sessionsStorage.get(),
      sortDirection: "desc",
      filter: null,
      changePageFilter: "0",
      modalInfo: { title: "", content: "" },
      alert: {
        content: "Added Succesfully",
        ok: "ok",
      },
      getTallyInvoiceList: [],
      visible: false,
      openLeft: "left",
      showCal: false,
      openRight: "right",
      startDate: "2017-09-05",
      endDate: "2017-09-15",
      dateRange: {
        startDate: "",
        endDate: "",
      },
      locale: {
        direction: "ltr",
        format: "mm/dd/yyyy",
        separator: " - ",
        applyLabel: "Apply",
        cancelLabel: "Cancel",
        weekLabel: "W",
        customRangeLabel: "Custom Range",
        daysOfWeek: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        monthNames: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        firstDay: 0,
      },
      value1: [new Date(2019, 9, 8), new Date(2019, 9, 19)],
      value2: [],
      langType: {
        pickers: ["Today", "Yesterday", "This Month", "This Year"],
      },

      adminToggle: this.$sessionsStorage.get("designation"),

      lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),
      billingclosingReason: "",
    };
  },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },
  mounted() {},

  beforeDestroy() {},

  destroyed() {},

  components: {
    // Loading,
    DatePicker,
    ModelListSelect,
    ClientUserService,
    CommonService,
    CustomLoader,
    DateRangePicker,
    BillingInvCard,
    userBasedClient,
    DocForm,
    InvExpSummary,
    ContainerSummary,
    JobWisePaymentsDetails,
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.Columns.filter((f) => f.sortable).map((f) => {
        return { text: f.label, value: f.key };
      });
    },
  },
  methods: {
    getCurrentLastDate() {
      var today = new Date();
      // var firstDay = new Date(today.getTime() - (24 * 60 * 60 * 1000)); // Yesterday
      // var firstDay = new Date(today.getTime() - (9 * 24 * 60 * 60 * 1000)); // 9 days ago
      var firstDay = new Date(today.getTime() - (5 * 24 * 60 * 60 * 1000)); // 9 days ago
      var lastDay = new Date(today); // Today

      var firstDay_dd = String(firstDay.getDate()).padStart(2, "0");
      var firstDay_mm = String(firstDay.getMonth() + 1).padStart(2, "0");
      var firstDay_yyyy = firstDay.getFullYear();
      var formattedFirstDay = firstDay_yyyy + "/" + firstDay_mm + "/" + firstDay_dd;

      var lastDay_dd = String(lastDay.getDate()).padStart(2, "0");
      var lastDay_mm = String(lastDay.getMonth() + 1).padStart(2, "0");
      var lastDay_yyyy = lastDay.getFullYear();
      var formattedLastDay = lastDay_yyyy + "/" + lastDay_mm + "/" + lastDay_dd;

      this.startDate = formattedLastDay;
      this.dateRange = {
        startDate: formattedFirstDay,
        endDate: formattedLastDay,
      };
      // alert(this.Filter.QDFilter)
      this.getAllBillingInvList("Normal", "0", "0", "1", "1");
    },
    getReports(id, btnName) {
      this.ExcelBtnName = "Downloading Please Wait .....";
      this.getAllBillingInvList("Excell", "0", "0", "1", "1");
    },
    getAllBillingInvList(type, filterIdD, CURRENT, SEARCH, pageNumber) {
      this.isLoading = true;
      this.getTallyInvoiceList = [];
      let payload = {};
      if (type == "Normal") {
        this.isLoading = true;
      }
      this.Filter.dateRange = this.dateRange;
      payload = {
        itemCode: "getTallyInvoiceList",
        type: type,
        DCfilterId: filterIdD,
        searchVal: this.filter,
        DCfilterId: filterIdD,
        fromSearch: SEARCH,
        currentPage: CURRENT,
        perPage: this.perPage,
        Filter: this.Filter,
      };

      CommonService.getAllExpenseList(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          console.log();
          if (status == 200 && data.FLAG == 1) {
            this.totalRows = data.totalRows;
            if (SEARCH != "2") {
              this.currentPage = 1;
              if (this.lastVisitPage && this.$sessionsStorage.get("lastVisitPage")) {
                this.currentPage = parseInt(this.lastVisitPage);
              }
            } else {
              this.currentPage = pageNumber;
            }
            if (type == "Excel") {
              if (data.getTallyInvoiceList.length > 0) {
                this.getTallyInvoiceList = data.getTallyInvoiceList;
              }
              this.ExcelBtnName = "Export As Excel";
              this.totalRows = data.totalRows;
              window.location.href =
                `https://uploadsp.pridel.com/Pridel_Reports/` + data.excelName;
            } else {
              if (data.getTallyInvoiceList.length > 0) {
                this.getTallyInvoiceList = data.getTallyInvoiceList;
                this.totalRows = data.totalRows;
              }
            }
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on getTallyInvoiceList Error: ", error);
        });
    },
    showDocModal(item) {
      this.ALLMODULE = "";
      this.JOBSERIES = "";
      this.ALLMODULE = item.allModuleId;
      this.JOBSERIES = item.JOBNO;
      this.$refs["doc-modal"].show();
    },
    hideDocModal() {
      this.$refs["doc-modal"].hide();
    },
    goBack() {
      window.history.go(-1);
    },
    clearBranch() {
      this.Filter.BranchFilter = "";
    },
    clearFilter() {
      this.Filter = {
        jobTypeFilter: "FF",
        StatusFilter: "Active",
        shipmentTypeFilter: "1",
        transportTypeFilter: "Export",
        userFilter:
          this.$sessionsStorage.get("designation") == "Admin"
            ? ""
            : this.$sessionsStorage.get("departmentName").indexOf("Accounts") >= 0
            ? ""
            : this.$sessionsStorage.get("userId"),
        clientIdFilter: "",
        BranchFilter: "",
        SlineFilter: "",
      };
      this.dateRange = {
        startDate: "",
        endDate: "",
      };
    },
    debounceSearch(event) {
      clearTimeout(this.debounce);
      if(this.filter){
        this.Filter = {
        jobTypeFilter: "",
        StatusFilter: "",
        shipmentTypeFilter: "",
        transportTypeFilter: "",
        userFilter:
          this.$sessionsStorage.get("designation") == "Admin"
            ? ""
            : this.$sessionsStorage.get("departmentName").indexOf("Accounts") >= 0
            ? ""
            : this.$sessionsStorage.get("userId"),
        clientIdFilter: "",
        BranchFilter: "",
        SlineFilter: "",
      };
      }
      this.debounce = setTimeout(() => {
        this.getAllBillingInvList("Normal", "0", "0", "1", "1");
      }, 1000);
    },
    fetchLastPage(event) {
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = parseInt(event) * this.perPage - this.perPage;
      }
      this.getAllBillingInvList("Normal", "0", CURRENT, "2", event);
    },
    filterClear() {
      this.filter = "";
      this.getAllBillingInvList("Normal", "0", "0", "1", "1");
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      // this.totalRows = filteredItems.length;
      // this.currentPage = 1;
    },
    onPageChange: function (event) {
      this.$sessionsStorage.set("lastVisitPage", event);
      this.$sessionsStorage.set("oldRoute", this.$router.history.current.fullPath);
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = event * this.perPage - this.perPage;
      }

      this.getAllBillingInvList("Normal", "0", CURRENT, "2", event);
    },
    closeBillOk() {
      // Add your billing close confirmation logic here
      this.closeModalConfirm();
    },
    closeModalConfirm() {
      this.$refs["modal-close-conf"].hide();
      this.billingclosingReason = "";
    },
  },
};
</script>

<style>
.md-direction-bottom-right {
  width: 30% !important;
}
.mrgtop-2per {
  margin-top: 1%;
}
.mrgtop-5px {
  margin-top: 0px;
}
.center {
  text-align: center;
}
.heght-1px {
  height: 1px;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}
.md-button-color {
  background-color: #607d8d !important;
}

.md-button-color-toggle {
  background-color: rgba(153, 153, 153, 0.4) !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
</style>



// WEBPACK FOOTER //
// billingInvDash.vue?f8f448aa